import { cn } from '../../lib/utils'
import { memberColors, memberColorKeys } from '../../styles/tokens'

export const ColorPicker = ({ value, onChange, label }) => (
  <div className="space-y-2">
    {label && <p className="text-sm font-medium text-text-primary">{label}</p>}
    <div className="flex flex-wrap gap-3">
      {memberColorKeys.map((key) => (
        <button
          key={key}
          type="button"
          onClick={() => onChange(key)}
          aria-label={key}
          aria-pressed={value === key}
          className={cn(
            'w-8 h-8 rounded-full transition-all duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary',
            value === key
              ? 'ring-2 ring-offset-2 ring-primary scale-110 shadow-md'
              : 'hover:scale-105 hover:shadow-sm'
          )}
          style={{ backgroundColor: memberColors[key] }}
        />
      ))}
    </div>
    {value && (
      <p className="text-xs text-text-muted capitalize">Selected: {value}</p>
    )}
  </div>
)
